import { Action, ActionReducer } from '@ngrx/store';
import { ParameterType } from '../../../_generated';
import { ParameterIdAction, ParameterIdActionType } from '../../actionstypes/selected-id/parameter-id.actiontype';

const initialState: Map<ParameterType, number[]> = new Map();

const parameterIdReducer = (state = initialState, action: ParameterIdActionType): Map<ParameterType, number[]> => {
  switch (action.type) {
    case ParameterIdAction.Set:
      return new Map(state).set(action.payload.parameterType, action.payload.parameterIds);

    case ParameterIdAction.Reset:
      return new Map();

    case ParameterIdAction.Sync:
      if (state.size === 0) {
        return state;
      }

      return new Map(state).set(action.payload.parameterType, action.payload.parameterIds);

    case ParameterIdAction.Add:
      if (state.get(action.payload.parameterType)?.includes(action.payload.parameterId)) {
        return state;
      }
      return new Map(state).set(action.payload.parameterType, [...(state.get(action.payload.parameterType) || []), action.payload.parameterId]);

    case ParameterIdAction.Remove:
      return new Map(state).set(
        action.payload.parameterType,
        state.get(action.payload.parameterType)?.filter((id) => id !== action.payload.parameterId) || [],
      );

    default:
      return state;
  }
};

export default parameterIdReducer as ActionReducer<Map<ParameterType, number[]>, Action<string>>;
